import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';

export const getPhoneDataList = createAsyncThunk('Esim/GetSubscribersDetails', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getSubscribersDetails', []);
    return result.Body?.result?.data;
  } catch (err) {
    console.log(err);
  }
});

const initialState = {
  modeType: '',
  currentStage: 0,
  phoneDataList: [],
  startStepIndex: 0,
  currentPhoneNumberId: 0,
  currentPhone: {},
  isCurrentPhoneLoad: false,
  niudDataList: [],
  saleDataList: [],
  isNumberChosen: true,
};

const esimBlockSlice = createSlice({
  name: 'esim',
  initialState: initialState,

  reducers: {
    resetState: (state) => initialState,
    moveNextPage: (state, action) => {
      if (state.currentStage == 3) {
        state.currentStage = 0;
      } else if (state.currentPhone !== '') {
        state.currentStage += 1;
      } else {
        alert('בבקשה בחר מספר טלפון על מנת להתחיל את תהליך ההפעלה');
      }
    },
    backToChooseNumberPage: (state, action) => {
      if (state.currentStage !== 0) {
        state.currentStage = 0;
      }
    },
    setFirstPage: (state, action) => {
      if (state.currentStage.length > 1) {
        return 0;
      } else {
        return 1;
      }
    },

    setCurrentPhoneNumberId: (state, action) => {
      state.currentPhoneNumberId = action.payload;
    },
    setCurrentPhone: (state, action) => {
      state.currentPhone = action.payload;
    },
    setModeType: (state, action) => {
      state.modeType = action.payload;
    },
    setPhoneListData: (state, action) => {
      state.phoneDataList = action.payload;
      for (let i = 0; i < action.payload.length; i++) {
        if (action.payload[i]?.stickerNumber !== undefined && action.payload[i]?.stickerNumber !== '') {
          state.niudDataList.push(action.payload[i]);
        } else {
          state.saleDataList.push(action.payload[i]);
        }
      }
    },
    setIsCurrentPhoneLoad: (state, action) => {
      state.isCurrentPhoneLoad = action.payload;
    },

    setIsNumberChosen: (state, action) => {
      state.isNumberChosen = action.payload;
    },
  },

  extraReducers: {
    [getPhoneDataList.fulfilled]: (state, action) => {
      state.phoneDataList = action.payload;
    },
  },
});

export const {
  resetState,
  moveNextPage,
  backToChooseNumberPage,
  setCurrentPhoneNumberId,
  setCurrentPhone,
  setModeType,
  setPhoneListData,
  setFirstPage,
  setIsCurrentPhoneLoad,
  setTwoListPhoneNumbers,
  setIsNumberChosen,
} = esimBlockSlice.actions;

export default esimBlockSlice.reducer;
